module.exports = __webpack_public_path__ + "img/wechat.4f8fc5c.png";